import { provide, inject } from 'vue';
import posthog from 'posthog-js';

const PostHogSymbol = Symbol('PostHog');

export function usePostHogProvider() {
    if (import.meta.env.DEV) return;

    const posthogInstance = posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
        api_host: 'https://us.i.posthog.com',
        person_profiles: 'identified_only',
    });

    provide(PostHogSymbol, posthogInstance);

    return posthogInstance;
}

export function usePostHog() {
    if (import.meta.env.DEV) return;

    const posthogInstance = inject(PostHogSymbol);
    if (!posthogInstance) {
        throw new Error('PostHog has not been provided');
    }
    return posthogInstance;
}
